export enum GameVariant {
  Bingo = 'Bingo' // can also be Slot, Live, etc. if needed
}
